import { User } from '@nextforce/api'
import { AnalyticsConstants } from 'app/analytics/constants'
import { useAnalytics } from 'app/analytics/context'
import { useAuthentication } from 'authentication/context'
import { useEffect, useRef } from 'react'
import { AppState } from 'react-native'
import { useUser } from './queries/detail'

export interface UserData {
  user: User | undefined
  isLoading: boolean
  isError: boolean
  userError: unknown
}
interface Props {
  children: React.ReactNode
}
export function UserAnalyticsLayer({ children }: Props) {
  const userQuery = useUser()
  const user = userQuery.data

  const { status } = useAuthentication()
  const analytics = useAnalytics()
  const appState = useRef(AppState.currentState)
  useEffect(() => {
    if (status === 'loggedIn' && user) {
      analytics
        .track(user.id, AnalyticsConstants.ANALYTICS_EVENT_LOGIN)
        .catch(err => console.error('Error tracking login ', err))
      analytics
        .track(user.id, AnalyticsConstants.ANALYTICS_EVENT_APP)
        .catch(err => console.error('Error tracking app opened ', err))
    }
  }, [analytics, status, user])

  useEffect(() => {
    const subscription = AppState.addEventListener('change', nextAppState => {
      if (
        appState.current === 'background' &&
        nextAppState === 'active' &&
        user
      ) {
        analytics
          .track(user?.id, AnalyticsConstants.ANALYTICS_EVENT_APP)
          .catch(err => console.error('Error tracking app opened ', err))
      }
      appState.current = nextAppState
    })

    return () => {
      subscription.remove()
    }
  }, [analytics, user])
  return <>{children}</>
}
